import { Icon } from '../../components/Icon.tsx';
import { PRIORITY_LABEL, type IssuePriority } from './types.ts';

const PRIORITIES: IssuePriority[] = ['LOW', 'NORMAL', 'URGENT'];

/** M3 segmented button for Low / Normal / Urgent (check mark on the chosen segment). */
export function PriorityPicker({ value, onChange }: { value: IssuePriority; onChange: (p: IssuePriority) => void }): JSX.Element {
  return (
    <fieldset className="space-y-1.5">
      <legend className="field-label">Priority</legend>
      <div className="grid grid-cols-3 overflow-hidden rounded-full border border-[hsl(var(--border-strong))]" role="radiogroup" aria-label="Priority">
        {PRIORITIES.map((p) => {
          const on = value === p;
          return (
            <button
              key={p}
              type="button"
              role="radio"
              aria-checked={on}
              onClick={() => onChange(p)}
              className={`flex h-11 items-center justify-center gap-1.5 border-s border-[hsl(var(--border-strong))] text-sm font-medium transition-colors first:border-s-0 active:bg-[hsl(var(--foreground)/0.1)] ${
                on
                  ? p === 'URGENT'
                    ? 'bg-destructive/10 text-destructive'
                    : 'bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]'
                  : 'text-foreground/80 hover:bg-[hsl(var(--foreground)/0.05)]'
              }`}
            >
              {on && <Icon name="check" size={18} />}
              {PRIORITY_LABEL[p]}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
